<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-bullseye-arrow" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Simulações de Laudos Express</div>
      </template>
      <v-btn
        id="btn-nova-simulacao"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Simulação
      </v-btn>
      <v-text-field
        id="simulacao-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-laudos-incrementais ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Simulação do Laudo Express" />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma simulação do laudo express disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.data_processamento`]="{ item }">
          {{ item.data_processamento | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-simulacao"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-simulacao"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-simulacao"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.status == 'SUCESSO'" @click="duplicarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Duplicar</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.titulo)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true), (dialogCreationLogData = { username: item.usuario.nome, created: item.created }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar as simulações de laudos express</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Simulação do Laudo Express #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a simulação do laudo express
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-detalhes title="Detalhes da Simulação" :show-dialog="dialogDetalhes" @changeValue="dialogDetalhes = $event">
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          :mobile-breakpoint="0"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td
                v-if="row.item.parametro.substr(0, 10) == 'Mapeamento'"
                class="button mapeamento-td-laudos-incrementais"
                @click="baixarCsvMapeamento(row.item.valor)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">clique aqui para baixar</div>
                  </template>
                  <span>Clique aqui para baixar o mapeamento {{ row.item.ref }}</span>
                </v-tooltip>
              </td>
              <td
                v-else-if="'arquivo_id' in row.item"
                class="mapeamento-td-laudos-incrementais"
                @click="downloadArquivoById(row.item.arquivo_id, row.item.arquivo_nome)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-progress-circular v-if="loadingDownloadArquivoById" indeterminate color="primary" size="20" />
                      <span v-else>{{ row.item.arquivo_nome }}</span>
                    </div>
                  </template>
                  <span v-if="loadingDownloadArquivoById">AGUARDE :: Baixando arquivo [{{ row.item.arquivo_nome }}]...</span>
                  <span v-else>Clique aqui para baixar o arquivo</span>
                </v-tooltip>
              </td>
              <td v-else-if="row.item.valor && typeof row.item.valor === 'object' && 'logs_tecnicos' in row.item.valor">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-btn-logs"
                      icon
                      color="black"
                      :loading="loadingLogsTecnicos"
                      v-bind="attrs"
                      @click="downloadLogsTecnicos(row.item.valor.id)"
                      v-on="on"
                    >
                      <v-icon size="18">mdi-file-download-outline</v-icon>
                    </v-btn>
                  </template>
                  <span v-if="loadingLogsTecnicos">Baixando...</span>
                  <span v-else>Clique aqui para baixar os logs técnicos</span>
                </v-tooltip>
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-detalhes>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </v-container>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog.vue'),
      DialogDelete: () => import('@/components/general/DialogDelete.vue'),
      DialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['switchProcessamentosExpirados', 'rechargeTable'],

    data: () => ({
      powerupService: SimulacoesLaudosIncrementaisService,
      powerupEntityName: 'Simulação do Laudo Express',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      dialogDelete: false,
      dialogDeleteData: { id: undefined, titulo: undefined },
      dialogDetalhesHeader: [
        { text: 'Parâmetro', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ],
      loadingLogsTecnicos: false
    }),

    methods: {
      openDialogDetalhes(item) {
        let arrayParametros = [
          { parametro: 'AIS Data Base:', valor: this.formatDate(item.data_base) },
          {
            parametro: 'Origem da Base Contábil:',
            valor: item.origem_dados_ais == 'AIS' ? 'AIS IMPORTADO' : item.origem_dados_ais
          },
          { parametro: 'Possui Obra?', valor: item.possui_obra ? 'SIM' : 'NÃO' },
          { parametro: 'Possui Material?', valor: item.possui_material ? 'SIM' : 'NÃO' },
          { parametro: 'Deprecia no Próprio Mês?', valor: item.deprecia_mes ? 'SIM' : 'NÃO' },
          { parametro: 'Almoxarifado em Operação', valor: item.vlr_almoxarifado_em_operacao },
          {
            parametro: 'Período de Imobilização:',
            valor: this.getPeriodoImobilizacao(item.data_imobilizacao_inicio, item.data_imobilizacao_fim)
          },
          { parametro: 'Origem do Banco de Preços:', valor: item.origem_dados_banco_precos }
        ];

        if (item.origem_dados_banco_precos == 'CALCULO') {
          arrayParametros.push({
            parametro: 'Cálculo de Banco de Preços:',
            valor: `#${item.banco_preco_calculo_id} - ${item.banco_preco_calculo.titulo}`
          });
        } else {
          if (item.banco_precos_materiais_arquivo_id) {
            arrayParametros.push(
              {
                parametro: 'Arquivo Banco de Preços Materiais:',
                arquivo_nome: item.arquivo_banco_precos_materiais.arquivo,
                arquivo_id: item.arquivo_banco_precos_materiais.id
              },
              {
                parametro: 'Mapeamento Banco de Preços Materiais:',
                valor: JSON.parse(item.banco_precos_materiais_mapeamento_arquivo),
                ref: 'banco de preços materiais'
              },
              { parametro: 'Delimitador:', valor: item.banco_precos_materiais_delimitador },
              { parametro: 'Invólucro:', valor: item.banco_precos_materiais_involucro },
              { parametro: 'Escape:', valor: item.banco_precos_materiais_escape }
            );
          }
          if (item.banco_precos_tucagens_arquivo_id) {
            arrayParametros.push(
              {
                parametro: 'Arquivo Banco de Preços Tucagens:',
                arquivo_nome: item.arquivo_banco_precos_tucagens.arquivo,
                arquivo_id: item.arquivo_banco_precos_tucagens.id
              },
              {
                parametro: 'Mapeamento Banco de Preços Tucagens:',
                valor: JSON.parse(item.banco_precos_tucagens_mapeamento_arquivo),
                ref: 'banco de preços tucagens'
              },
              { parametro: 'Delimitador:', valor: item.banco_precos_tucagens_delimitador },
              { parametro: 'Invólucro:', valor: item.banco_precos_tucagens_involucro },
              { parametro: 'Escape:', valor: item.banco_precos_tucagens_escape }
            );
          }
        }

        arrayParametros.push({
          parametro: 'Possui arquivo de % de Fat. Saneamento por Obra',
          valor: item.arquivo_perc_saneamento_obra_id ? 'SIM' : 'NÃO'
        });

        let objPercentuais = JSON.parse(item.percentuais);
        Object.keys(objPercentuais).forEach((key) => {
          if (objPercentuais[key]['tipoTipologia'] === 'Saneamento do VOC' && item.calculo_com_ca_aneel_id != null) {
            const calculo = `#${item.calculo_com_ca_aneel_id} - ${item.calculo_com_ca_aneel.nome}`;
            arrayParametros.push({ parametro: `Cálculo para ${key}`, valor: calculo });
          } else {
            arrayParametros.push({
              parametro: `Percentual para ${key}:`,
              valor: `% Saneamento: ${objPercentuais[key]['perc_fator_saneamento']}`
            });
          }
        });

        if (this.userIsAdmin && ['SUCESSO', 'FALHA'].includes(item.status)) {
          arrayParametros.push(
            { parametro: ' ', valor: ' ' },
            { parametro: 'LOGS TÉCNICOS:', valor: { id: item.id, logs_tecnicos: true } }
          );
        }

        this.dialogDetalhesData = arrayParametros;
        this.dialogDetalhes = true;
      },

      baixarCsvMapeamento(mapeamento) {
        let arrayMapeamento = [];
        Object.keys(mapeamento).forEach((key) => {
          arrayMapeamento.push([key] + ' => ' + mapeamento[key]);
        });

        var _gerarCsv = function () {
          var csv = 'NOME DA COLUNA NO SISTEMA => NOME DA COLUNA NO ARQUIVO CSV\n\n';
          arrayMapeamento.forEach((row) => {
            csv += row;
            csv += '\n';
          });

          var hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'mapeamento.csv';
          hiddenElement.click();
        };
        _gerarCsv();
      },

      getPeriodoImobilizacao(dataImobilizacaoInicio, dataImobilizacaoFim) {
        return this.formatDate(dataImobilizacaoInicio) + ' até ' + this.formatDate(dataImobilizacaoFim);
      }
    }
  };
</script>

<style>
  .mapeamento-td-laudos-incrementais {
    color: #e5502c;
    text-decoration: underline;
    font-weight: bolder;
    cursor: pointer;
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
